export const CUSTOM_GAME_CREATE_COST = 50;
export const CUSTOM_GAME_AI_CLUE_COST = 100;

export const CUSTOM_STYLE_GRID_5 = 'grid_5';
export const CUSTOM_STYLE_OPEN_ENDED = 'open_ended';
export const CUSTOM_PRIVATE_SHARE_CARD_TITLE = 'Zoomed In Custom';
export const CUSTOM_PRIVATE_SHARE_CARD_META = 'Share without revealing answers';
export const CUSTOM_PRIVATE_SHARE_FILE_PREFIX = 'zoomed-in-custom';
export const CUSTOM_PRIVATE_SHARE_TEXT = 'Play for free at zoomed-in.com';
export const CUSTOM_HUB_VIEW_CREATE = 'create';
export const CUSTOM_HUB_VIEW_MANAGE = 'manage';
export const CUSTOM_HUB_CREATE_BUTTON_LABEL = '+ Create Your Own Game';
export const CUSTOM_HUB_MANAGE_BUTTON_LABEL = 'Manage Your Games';
export const CUSTOM_HUB_PUBLIC_GAMES_COMING_SOON_TEXT =
  'Create new custom games or manage your existing shared games.';

export const CUSTOM_WORD_MIN_LENGTH = 3;
export const CUSTOM_WORD_MAX_LENGTH = 12;
export const CUSTOM_GRID_WORD_LENGTH = 5;
export const CUSTOM_UNLIMITED_CLUE_REVEAL_CAP = 20;
export const CUSTOM_DEFAULT_FULL_ZOOM_OUT_ROW = 4;
export const CUSTOM_MIN_FULL_ZOOM_OUT_ROW = 2;
export const CUSTOM_DEFAULT_ZOOM_ORIGIN = Object.freeze({ x: 0.5, y: 0.5 });
export const CUSTOM_DEFAULT_ZOOM_RADIUS = 0.35;
export const CUSTOM_MIN_ZOOM = 100;
export const CUSTOM_INTERPOLATION_INITIAL_ZOOM = 600;
export const CUSTOM_ZOOM_BOUNDS = Object.freeze({
  initialZoom: CUSTOM_INTERPOLATION_INITIAL_ZOOM,
  minZoom: CUSTOM_MIN_ZOOM,
});
export const CUSTOM_FULL_REVEAL_GUESS_ROW = CUSTOM_DEFAULT_FULL_ZOOM_OUT_ROW;
export const CUSTOM_IMAGE_READY_HINT_TEXT = 'Image has fully loaded';
export const CUSTOM_KEEP_GUESSING_HINT_TEXT = 'Keep guessing to zoom out!';
export const CUSTOM_FULLY_ZOOMED_HINT_TEXT = 'Image is now fully zoomed out! Good luck';
export const CUSTOM_IMAGE_HINT_DISPLAY_MS = 3400;
export const CUSTOM_IMAGE_HINT_FADE_MS = 500;
export const CUSTOM_ZOOM_HINT_DISPLAY_MS = 2200;

export const buildCustomPresentLetterMask = ({ guessWord, letterStatuses }) => {
  const letters = String(guessWord || '').toUpperCase().split('');
  const statuses = Array.isArray(letterStatuses) ? letterStatuses : [];
  if (letters.length === 0) return [];

  return letters.map((_, index) => {
    const status = String(statuses[index] || '').toLowerCase();
    return status === 'present' || status === 'correct';
  });
};

export const getCustomZoomLevelForRadius = (radiusValue) => {
  const parsed = Number(radiusValue);
  const safeRadius =
    Number.isFinite(parsed) && parsed > 0
      ? Math.min(1, parsed)
      : CUSTOM_DEFAULT_ZOOM_RADIUS;
  const scaled =
    (CUSTOM_INTERPOLATION_INITIAL_ZOOM * CUSTOM_DEFAULT_ZOOM_RADIUS) / safeRadius;
  return Math.max(CUSTOM_MIN_ZOOM, Math.min(2400, Math.round(scaled)));
};

export const getCustomZoomInterpolationBounds = (zoomRadius) => ({
  initialZoom: getCustomZoomLevelForRadius(zoomRadius),
  minZoom: CUSTOM_MIN_ZOOM,
});

export const getCustomProgressiveZoomLevel = ({
  zoomRadius,
  guessesUsed,
  fullZoomOutRow = CUSTOM_DEFAULT_FULL_ZOOM_OUT_ROW,
}) => {
  const { initialZoom: startZoom } = getCustomZoomInterpolationBounds(zoomRadius);
  const used = Math.max(0, Number(guessesUsed) || 0);
  const normalizedFullZoomOutRow = Math.max(
    CUSTOM_MIN_FULL_ZOOM_OUT_ROW,
    Math.floor(Number(fullZoomOutRow) || CUSTOM_DEFAULT_FULL_ZOOM_OUT_ROW),
  );
  // Reaching full zoom-out row means guessesUsed has advanced by (row - 1).
  const revealSteps = Math.max(1, normalizedFullZoomOutRow - 1);
  const progress = Math.min(1, used / revealSteps);
  if (startZoom <= CUSTOM_MIN_ZOOM) return CUSTOM_MIN_ZOOM;

  // Use equal absolute zoom steps per row so each reveal feels
  // close to the same amount of zoom-out in UI terms.
  const value = startZoom - (startZoom - CUSTOM_MIN_ZOOM) * progress;
  return Math.round(Math.max(CUSTOM_MIN_ZOOM, value));
};

export const CUSTOM_MAX_GUESSES_OPTIONS = Object.freeze([5, 6]);

export const isCustomStyle = (value) =>
  value === CUSTOM_STYLE_GRID_5 || value === CUSTOM_STYLE_OPEN_ENDED;

export const isCustomWordLengthValid = ({ style, wordLength }) => {
  const length = Number(wordLength);
  if (!Number.isFinite(length)) return false;
  if (style === CUSTOM_STYLE_GRID_5) return length === CUSTOM_GRID_WORD_LENGTH;
  if (style === CUSTOM_STYLE_OPEN_ENDED) {
    return length >= CUSTOM_WORD_MIN_LENGTH && length <= CUSTOM_WORD_MAX_LENGTH;
  }
  return false;
};
